import { Injectable, Injector } from "@angular/core";
import * as qrcode from 'qrcode';
import { environment } from "src/environments/environment";
import { z } from "zod";
import { BankAccountTypeSchema } from "../../model/api";
import { IOModuleService } from "./IOModule.service";
import { ModuleService } from "./ModuleService";
export type ParkingVoucher = {
  settlement_time: string;
  terminal_id: string;
  receiver_phone: string;
  voucher_amount: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  voucher_brand: string;
  ref_number: string;
  voucher_code: string;
  voucher_pin: string;
  service: string;
  receipt_type: string;
}

export type CVInfo = { credit_voucher_value: string, credit_voucher_code: string, credit_voucher_pin: string }
export interface BusinessBill {
  settlement_time: string
  terminal_id: string
  convenience_fee: string
  vat: string
  total_deposited: string
  business: string
  service: string
  ref_number: string
  receipt_type: string
}


export interface GiftCard {
  settlement_time: string;
  terminal_id: string;
  receiver_phone: string;
  voucher_amount: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  voucher_brand: string;
  ref_number: string;
  voucher_code: string;
  voucher_pin: string;
  service: string;
  receipt_type: string;
  qrcode: string;
}

export interface GHDeposit {
  settlement_time: string;
  terminal_id: string;
  customer_name: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  account_number: string;
  amount: string;
  gaming_house: string;
  ref_number: string;
  service: string;
  receipt_type: string;
  old_balance: string;
  new_balance: string;
}

export interface GHWithdraw {
  settlement_time: string;
  terminal_id: string;
  account_number?: string;
  customer_name: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  amount: string;
  gaming_house: string;
  ref_number: string;
  service: string;
  receipt_type: string;
  old_balance: string;
  new_balance: string;
}

export interface SCDeposit {
  settlement_time: string;
  terminal_id: string;
  customer_name: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  ref_number: string;
  service: string;
  receipt_type: string;
  old_balance: string;
  new_balance: string;
}

export interface SCWithdraw {
  settlement_time: string;
  terminal_id: string;
  customer_name: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  amount_paid: string;
  ref_number: string;
  service: string;
  receipt_type: string;
  old_balance: string;
  new_balance: string;
}

export interface SDLoad {
  settlement_time: string;
  terminal_id: string;
  user: string;
  receiver_name: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  amount: string;
  ref_number: string;
  service: string;
  receipt_type: string;
  status: string;
}
export interface SDWithdraw {
  settlement_time: string;
  terminal_id: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  amount: string;
  ref_number: string;
  service: string;
  receipt_type: string;
}

export interface SMLoad {
  settlement_time: string;
  terminal_id: string;
  name: string;
  email: string;
  mobile: string;
  convenience_fee: string;
  vat: string;
  cash: string;
  amount: string;
  ref_number: string;
  service: string;
  receipt_type: string;
  status: string;
}

export interface BPLoad {
  settlement_time: string;
  terminal_id: string;
  convenience_fee: string;
  vat: string;
  total_deposited: string;
  business: string;
  service: string;
  ref_number: string;
  receipt_type: string;
}

export interface GVLoad {
  settlement_time: string;
  terminal_id: string;
  convenience_fee: string;
  vat: string;
  amount: string;
  total_deposited: string;
  invoice: string;
  reference: string;
  reference_id: string;
  name: string;
  receipt_type: string;
}

export interface TopupReceiptData {
  settlement_time: string;
  terminal_id: string;
  provider: any;
  product: string;
  mobile_number: string;
  amount: string;
  service: string;
  provider_ref_number: string;
  settlement_transaction_id: string;
  receipt_type: string;
}

export interface SENDMONEY {
  settlement_time: string;
  terminal_id: string;
  convenience_fee: string;
  vat: string;
  total_deposited: string;
  service: string;
  cashout_reference: string;
  receipt_type: string;
  location_island: string;
  delivery_method: string;
}

export interface CREDITVOUCHER {
  settlement_time: string;
  terminal_id: string;
  voucher_value: string;
  voucher_code: string;
  voucher_pin: string;
  service: string;
  message?: string;
  fee: number;
  vat: number;
  ref_number: string;
}


export interface UTILITY {
  settlement_time: string;
  terminal_id: string;
  convenience_fee: string;
  vat: string;
  total_deposited: string;
  service: string;
  cashout_reference: string;
  receipt_type: string;
  biller: string;
  transaction_id: string;
  account_number: string;
  account_name: string;
}

export interface BANKDEPOSIT {
  settlement_time: string;
  terminal_id: string;
  total_deposited: string;
  delivery_type: string;
  delivery_fee: string;
  recipient: string;
  recipient_accountNumber: string;
  recipient_accountType: z.infer<typeof BankAccountTypeSchema>;
  recipient_bankBranch: string;
  recipient_bankName: string;
  service: string;
  cashout_reference: string;
  receipt_type: string;

}
export interface CardWithdrawal {
  settlement_time: string;
  terminal_id: string;
  amount: string;
  convenience_fee: string;
  vat: string;
  service: string;
  receipt_type: string;
}
export interface CardDeposit {
  settlement_time: string;
  terminal_id: string;
  amount: string;
  convenience_fee: string;
  vat: string;
  service: string;
  receipt_type: string;
}

export interface WUSend {
  sender: string,
  sender_address: string,
  telno: string,
  sender_id_type: string,
  sender_id_number: string,
  receiver: string,
  question: string,
  answer: string,
  optional_services: string,
  receiver_city: string,
  receiver_state: string,
  receiver_country: string,
  date_time: string,
  agent_name: string,
  terminal_id: string,
  destination_country: string,
  mtcn: string,
  collection_currency: string,
  amount: string,
  charge: string,
  promotion_code: string,
  vat: string,
  tin_id: string,
  fx_fee: string,
  stamp_tax: string,
  convenience_fee: string,
  total: string,
  payout_amount: string,
  total_tax: string,
  exchange_rate: string,
  service: string,
  receipt_type: 'wu_send',
}
export interface WUReceive {
  receiver: string,
  receiver_address: string,
  receiver_id_type: string,
  receiver_id_number: string,
  sender: string,
  date_time: string,
  agent_name: string,
  terminal_id: string,
  originating_country: string,
  mtcn: string,
  payout_currency: string,
  payout_cash: string,
  sent_amount: string,
  sent_currency: string,
  voucher_amount: string,
  voucher_code: string,
  voucher_pin: string,
  exchange_rate: string,
  tax: string,
  total: string,
  service: string,
  receipt_type: 'wu_receive',
}

// type Var = `{{ ${string} }}`
// type KeyField<T extends Record<string, unknown>> =
//   Var extends `{{ ${infer R} }}` ?
//   keyof T extends string
//   ? (keyof T extends R ? `{{ ${keyof T} }}` : never) : never : never;

export type IReceiptItem<T extends Record<string, unknown>> =
  {
    Type: "Text";
    Text: string;
    callback: 'left' | 'right' | 'center';
    Label?: string;
  } | (({
    Type: "Image";
    FilePath: string;
    HtmlPath: string;
  } | {
    Type: "QRCode";
    QRCodeSizeType: number;
    QRCodeStartPos: number;
    Text: string
  }) & {
    ImageMarginLeft?: number;
    ImageMarginTop?: number;
    ImageMarginBottom?: number;
    ImageMarginRight?: number;
  })

@Injectable({
  providedIn: 'root'
})

export class ReceiptPrinterModule extends ModuleService {
  length = 40
  // lengthHTML = 46

  modelsHTML = [
    "ReceiptPrinter.Custom.VKP80II",
    "ReceiptPrinter.Custom.VKP80IIETH",
    "ReceiptPrinter.Custom.VKP80III",
    "ReceiptPrinter.Custom.TG02H",
    "ReceiptPrinter.Custom.KPM216E2",
    "ReceiptPrinter.Epson.TMSeries",
    "ReceiptPrinter.Pyramid.Reliance",
    "ReceiptPrinter.Generic.Any",
  ];
  modelsJSON = [
    "ReceiptPrinter.GenMega.RPU",
  ]
  spacer = " "
  is_html = !environment.production
  fontSize = 11
  fontFamily = 'Arial'

  constructor(public injector: Injector, public io_module: IOModuleService) {
    super("Receipt_Printer", injector)
    this.logger.log('Receipt_Printer constructor')

    // always connected
    this.connection$.subscribe(() => {
      this.is_html = this.modelsHTML.indexOf(this.DeviceManagerInterface) >= 0
      if (this.is_html) {
        this.length = 45;
      }
    })
  }

  public printParkingVoucherReceipt(data: ParkingVoucher, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getParkingVoucherReceiptTemplate(), data)
    return this.printReceipt(this.getParkingVoucherReceiptTemplate(), data)
  }

  public printGiftCardReceipt(data: GiftCard, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getGiftCardReceiptTemplate(), data)
    return this.printReceipt(this.getGiftCardReceiptTemplate(), data)
  }

  public printGHDepositReceipt(data: GHDeposit, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getGHDepositReceiptTemplate(), data)
    return this.printReceipt(this.getGHDepositReceiptTemplate(), data)
  }
  public printGHWithdrawReceipt(data: GHWithdraw, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getGHWithdrawReceiptTemplate(), data)
    return this.printReceipt(this.getGHWithdrawReceiptTemplate(), data)
  }

  public printSuncashReceipt(data: SCWithdraw | SCDeposit, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getSuncashReceiptTemplate(), data)
    return this.printReceipt(this.getSuncashReceiptTemplate(), data)
  }

  public printSuncashWithdrawReceipt(data: SCWithdraw | SCDeposit, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getSuncashWithdrawReceiptTemplate(), data)
    return this.printReceipt(this.getSuncashWithdrawReceiptTemplate(), data)
  }

  public printSandDollarReceipt(data: SDLoad, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getSandDollarReceiptTemplate(), data)
    return this.printReceipt(this.getSandDollarReceiptTemplate(), data)
  }

  public printSandDollarWithdrawalReceipt(data: SDWithdraw, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getSandDollarWithdrawalReceiptTemplate(), data)
    return this.printReceipt(this.getSandDollarWithdrawalReceiptTemplate(), data)
  }

  public printSendMoneyReceipt(data: SMLoad, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getSendMoneyReceiptTemplate(), data)
    return this.printReceipt(this.getSendMoneyReceiptTemplate(), data)
  }

  public printBusinessPaymentReceipt(data: BPLoad, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getBusinessPaymentReceiptTemplate(), data)
    return this.printReceipt(this.getBusinessPaymentReceiptTemplate(), data)
  }

  public printGovernmentPaymentReceipt(data: GVLoad, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getGovernmentReceiptTemplate(), data)
    return this.printReceipt(this.getGovernmentReceiptTemplate(), data)
  }
  public printTopupReceipt(data: TopupReceiptData, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getTopupReceiptTemplate(), data)
    return this.printReceipt(this.getTopupReceiptTemplate(), data)
  }
  public printSendMoneyToPersonReceipt(data: SENDMONEY, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getSendMoneyToPersonReceiptTemplate(), data)
    return this.printReceipt(this.getSendMoneyToPersonReceiptTemplate(), data)
  }

  public printCreditVoucherReceipt(data: CREDITVOUCHER) {
    data.message = typeof data.message != "undefined" ? data.message : "Unsuccessful transaction!"
    return this.printReceipt(this.getCreditVoucherReceiptTemplate(), data)
  }

  public printUtilityReceipt(data: UTILITY, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getUtilityReceiptTemplate(), data)
    return this.printReceipt(this.getUtilityReceiptTemplate(), data)
  }

  public printBankDepositReceipt(data: BANKDEPOSIT, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getBankDepositReceiptTemplate(), data)
    return this.printReceipt(this.getBankDepositReceiptTemplate(), data)
  }

  public printCardWithdrawalReceipt(data: CardWithdrawal, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getCardWithdrawalReceiptTemplate(), data)
    return this.printReceipt(this.getCardWithdrawalReceiptTemplate(), data)
  }

  public printCardDepositReceipt(data: CardDeposit, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getCardDepositReceiptTemplate(), data)
    return this.printReceipt(this.getCardDepositReceiptTemplate(), data)
  }
  public printWuSendReceipt(data: WUSend, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getWuSendReceiptTemplate(), data)
    return this.printReceipt(this.getWuSendReceiptTemplate(), data)
  }
  public printWuReceiveReceipt(data: WUReceive, type: any) {
    if (type == 'sms') return this.sendReceipt(this.getWuReceiveReceiptTemplate(), data)
    return this.printReceipt(this.getWuReceiveReceiptTemplate(), data)
  }

  public processReceipt<T extends Record<string, unknown>>(receipt: string, data: T, is_html: boolean = false) {
    for (let key in data) {
      receipt = this.replace_var(receipt, key, data)
    }
    let json_data = JSON.parse(receipt)

    json_data.Items = json_data.Items.map((item: IReceiptItem<typeof data>) => {
      let row: any = {
        ...item,
        ...(this.fontFamily ? {
          Font: {
            Name: this.fontFamily,
            EmSize: this.fontSize,
          }
        } : {})
      }
      delete row.callback
      delete row.Label
      if (this.is_html && is_html) {
        if (item.Type == 'QRCode' || item.Type == 'Image') {
          return row;
        }
        if (item.callback == "right") {
          row.Text = `<span style="font-size: ${this.fontSize}pt;${this.fontFamily ? `font-family: ${this.fontFamily}` : ``};text-align: left;display: inline-block;width: 41%;">${item.Label}</span><span style="font-size: ${this.fontSize}pt;${this.fontFamily ? `font-family: ${this.fontFamily}` : ``};text-align: right;display: inline-block;width: 55%;font-weight:bold;">${row.Text}</span>
      `;
        } else if (item.callback == "center") {
          row.Text = `<span style="font-size: ${this.fontSize}pt;${this.fontFamily ? `font-family: ${this.fontFamily}` : ``};text-align: center;display: inline-block;width: 100%;">${row.Text}</span>
        `;
        } else {
          row.Text = `<span style="font-size: ${this.fontSize}pt;${this.fontFamily ? `font-family: ${this.fontFamily}` : ``};text-align: left;display: inline-block;width: 100%;">${row.Text}</span>
          `;
        }
      } else {
        if (item.Type == 'QRCode' || item.Type == 'Image') {
          return row;
        }
        if (item.callback == "right") {
          row.Text = this.right(row.Text, item.Label)
        }
        if (item.callback == "center") {
          row.Text = this.center(row.Text)
        }
      }
      return row
    }).filter((item: any) => {
      return item.Text || item.Type == "Image"
    })
    return json_data
  }

  public parseToHTML(json_data: any) {
    let htmlReceiptText = '<!DOCTYPE html>\n<html>\n<head>\n</head>\n<body style="margin:0;">\n<div style="text-align:center; ">\n{{ content }}\n</div>\n</body>\n</html>';
    let content = '';
    let contentArray = json_data.Items.map(async (item: any, k: number) => {
      let tmp;
      switch (item.Type) {
        case "Text":
          tmp = "<div>" + item.Text + "</div>";
          break;
        case "Image":
          tmp = `<img src="${item.HtmlPath}" /> `;
          break;
        case "QRCode":
          let image = await qrcode.toDataURL(item.Text)
            .then((dataUrl) => {
              return `<div style="text-align:center;"><img src="${dataUrl}" /></div>`
            });
          tmp = image;
          break;
      }
      return tmp
    })
    return Promise.all(contentArray).then((contents) => {
      content += contents.join('\n')
      content += ('<br/>\n'.repeat(6));
      content += `<span style="font-size: ${this.fontSize}pt;text-align: center;display: inline-block;width: 100%;">${('-').repeat(this.length)}</span>`
      content += ('<br/>\n'.repeat(6));
      content += `<span style="font-size: ${this.fontSize}pt;text-align: center;display: inline-block;width: 100%;">${('-').repeat(this.length)}</span>`
      htmlReceiptText = htmlReceiptText.replace('{{ content }}', content);
      return htmlReceiptText
    })
  }

  public convertToString(json_data: any) {
    let content = ''
    json_data.Items.map((item: any) => {
      let newLine = false
      switch (item.Type) {
        case "Text":
          content += item.Text
          newLine = true
          break
        case "QRCode":
          content += item.Text
          newLine = true
          break
      }
      content += newLine ? '\n' : ''
    })
    return content
  }

  public printReceipt(receipt: any, data: any) {
    let json_data = this.processReceipt(receipt, data, this.is_html)
    if (data.credit_voucher) {
      data.credit_voucher = data.credit_voucher as CVInfo;
      json_data.Items = [
        ...json_data.Items,
        ...(this.processReceipt(this.receiptString({ Items: this.creditVoucher(data.credit_voucher) }), data.credit_voucher, this.is_html)).Items,
      ]
    }

    let promise = this.is_html ? this.parseToHTML(json_data) : Promise.resolve(JSON.stringify(json_data))

    return promise.then((receipt) => {
      if (!this.config.KIOSK_ENABLED) {
        return ReceiptPrinterModule.printToURL(receipt, this.is_html)
      }

      let cash = ((data.cash || '').toString()).replace('$', '') || 0;
      this.callMethod('receiptPrinter_SaveReceiptData', data.service, data.ref_number, (new Date).getTime(), cash, receipt, 0, !this.is_html).then((res: any) => {
        this.logger.log('receipt saved', res)
      }).catch((err: any) => {
        this.logger.log('failed to saved', err)
      })
      return this.requestPrintReceipt(receipt, this.is_html)
    })
  }

  public static printToURL(receipt: any, is_html: boolean = false) {
    return new Promise((resolve, reject) => {
      const blob = new Blob([receipt], { type: is_html ? "text/html" : "application/json" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
      resolve(true)
    })
  }

  public sendReceipt(receipt: any, data: any) {
    let json_data = this.processReceipt(receipt, data)
    if (data.credit_voucher) {
      data.credit_voucher = data.credit_voucher as CVInfo;
      json_data.Items = [
        ...json_data.Items,
        ...(this.processReceipt(this.receiptString({ Items: this.creditVoucher(data.credit_voucher) }), data.credit_voucher, false)).Items,
      ]
    }
    receipt = this.convertToString(json_data).replace('&', 'and')

    return Promise.resolve(receipt)
  }

  public requestPrintReceipt(content: string, html: boolean) {
    this.module(true)
    return new Promise((resolve, reject) => {
      this.callMethod(html ? 'receiptPrinter_PrintReceiptHtml' : 'receiptPrinter_PrintDocument', content)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.bypass) {
            resolve(JSON.parse(content))
          } else {
            reject(error)
          }
        }).finally(() => {
          this.module(false)
        })
    })
  }

  public module(toggle: boolean) {
    this.io_module.turnOutputDevice(toggle, 1).then((r) => {
      this.logger.log('turned ' + (toggle ? 'on' : 'off') + ' module 1')
    }).catch((e) => {
      this.logger.log('Failed to turn Module 1 ' + (toggle ? 'on' : 'off'))
      this.logger.log(e)
    })
  }

  public replace_var(str: any, name: string, value: any) {
    return str.replaceAll(`{{ ${name} }}`, value[name]);
  }

  public center(str: string) {
    let pad = (this.length - str.length)
    pad = pad > 0 ? pad : 1;
    return (this.spacer.repeat(Math.floor(pad / 2))) + str + (this.spacer.repeat(Math.floor(pad / 2) + (pad % 2 ? 1 : 0)))
  }

  public right(str: string, label?: string) {
    label = label || ""
    let emailPad = (str.indexOf('@') >= 0 ? 4 : 0)
    let pad = (this.length - (str.length + label.length + emailPad))
    pad = pad > 0 ? pad : 1;
    return label + (this.spacer.repeat(pad)) + str
  }

  public enter(times = 1) {
    return { Type: "Text", Text: "\n".repeat(times) }
  }

  public getParkingVoucherReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_times }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ receiver_phone }}", callback: "right", Label: "Receiver Phone" },
        { Type: "Text", Text: "{{ voucher_amount }}", callback: "right", Label: "Voucher Amount" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ voucher_brand }}", callback: "right", Label: "Voucher Brand" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        { Type: "Text", Text: "-".repeat(this.length), callback: "center" },
        { Type: "Text", Text: "Redeem voucher with code and PIN below", callback: "center" },
        { Type: "Text", Text: "{{ voucher_code }}", callback: "right", Label: "Voucher Code" },
        { Type: "Text", Text: "{{ voucher_pin }}", callback: "right", Label: "Voucher PIN" },
        { Type: "QRCode", ImageMarginTop: 0, ImageMarginBottom: 0, QRCodeSizeType: 7, QRCodeStartPos: 60 / 3, Text: "{{ voucher_code }}/{{ voucher_pin }}" },
        ...this.footer()
      ]
    });
  }

  public getGiftCardReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ receiver_phone }}", callback: "right", Label: "Receiver Phone" },
        { Type: "Text", Text: "{{ voucher_amount }}", callback: "right", Label: "Voucher Amount" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ voucher_brand }}", callback: "right", Label: "Voucher Brand" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        { Type: "Text", Text: "-".repeat(this.length), callback: "center" },
        { Type: "Text", Text: "Redeem voucher with code and PIN below", callback: "center" },
        { Type: "Text", Text: "{{ voucher_code }}", callback: "right", Label: "Voucher Code" },
        { Type: "Text", Text: "{{ voucher_pin }}", callback: "right", Label: "Voucher PIN" },
        { Type: "QRCode", ImageMarginTop: 0, ImageMarginBottom: 0, QRCodeSizeType: 7, QRCodeStartPos: 60 / 3, Text: "{{ qrcode }}" },
        ...this.footer()
      ]
    });
  }

  public getGHDepositReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ account_number }}", callback: "right", Label: "Account Number" },
        { Type: "Text", Text: "{{ customer_name }}", callback: "right", Label: "Customer Name" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Deposit Value" },
        { Type: "Text", Text: "{{ old_balance }}", callback: "right", Label: "Old Balance" },
        { Type: "Text", Text: "{{ new_balance }}", callback: "right", Label: "New Balance" },
        { Type: "Text", Text: "{{ gaming_house }}", callback: "right", Label: "Gaming House" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        ...this.footer()
      ]
    });
  }

  public getGHWithdrawReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ account_number}}", callback: "right", Label: "Account Number" },
        { Type: "Text", Text: "{{ customer_name }}", callback: "right", Label: "Customer Name" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Withdrawn" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Amount Paid" },
        { Type: "Text", Text: "{{ old_balance }}", callback: "right", Label: "Old Balance" },
        { Type: "Text", Text: "{{ new_balance }}", callback: "right", Label: "New Balance" },
        { Type: "Text", Text: "{{ gaming_house }}", callback: "right", Label: "Gaming House" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        ...this.footer()
      ]
    });
  }

  public getSuncashReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ customer_name }}", callback: "right", Label: "Customer Name" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ old_balance }}", callback: "right", Label: "Old Balance" },
        { Type: "Text", Text: "{{ new_balance }}", callback: "right", Label: "New Balance" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        ...this.footer()
      ]
    });
  }

  public getSuncashWithdrawReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ customer_name }}", callback: "right", Label: "Customer Name" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Withdrawn" },
        { Type: "Text", Text: "{{ amount_paid }}", callback: "right", Label: "Amount Paid" },
        { Type: "Text", Text: "{{ old_balance }}", callback: "right", Label: "Old Balance" },
        { Type: "Text", Text: "{{ new_balance }}", callback: "right", Label: "New Balance" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        ...this.footer()
      ]
    });
  }

  public getSandDollarReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        // { Type: "Text", Text: "{{ user }}", callback: "right", Label: "User" },
        { Type: "Text", Text: "{{ receiver_name }}", callback: "right", Label: "Receiver Name" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Receiver Gets" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        { Type: "Text", Text: "{{ status }}", callback: "right", Label: "Status" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        ...this.footer()
      ]
    });
  }
  public getSandDollarWithdrawalReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Withdrawn" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Amount Paid" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        ...this.footer()
      ]
    });
  }
  public getBusinessPaymentReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ total_deposited }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ business }}", callback: "right", Label: "Business" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        ...this.footer()
      ]
    });
  }

  public getGovernmentReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Amount" },
        { Type: "Text", Text: "{{ total_deposited }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ invoice }}", callback: "right", Label: "Invoice Number" },
        { Type: "Text", Text: "{{ reference }}", callback: "right", Label: "Reference Code" },
        { Type: "Text", Text: "{{ name }}", callback: "right", Label: "Name" },
        ...this.footer()
      ]
    });
  }

  public getSendMoneyReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ name }}", callback: "right", Label: "Name" },
        { Type: "Text", Text: "{{ email }}", callback: "right", Label: "Email" },
        { Type: "Text", Text: "{{ mobile }}", callback: "right", Label: "Mobile" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Total Deposited" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Receiver Gets" },
        { Type: "Text", Text: "{{ ref_number }}", callback: "right", Label: "Ref. Number" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        ...this.footer()
      ]
    });
  }

  // TOPUP
  public getTopupReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ provider }}", callback: "right", Label: "Provider" },
        { Type: "Text", Text: "{{ product }}", callback: "right", Label: "Product" },
        { Type: "Text", Text: "{{ mobile_number }}", callback: "right", Label: "Mobile Number" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Amount" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ provider_ref_number }}", callback: "right", Label: "Provider Ref. Number" },
        { Type: "Text", Text: "{{ settlement_transaction_id }}", callback: "right", Label: "transaction ID" },
        ...this.footer()
      ]
    });
  }
  //Send Money to person
  public getSendMoneyToPersonReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ location_island }}", callback: "right", Label: "Location and Island" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "Vat" },
        { Type: "Text", Text: "{{ total_deposited }}", callback: "right", Label: "Amount" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ delivery_method }}", callback: "right", Label: "Delivery Method" },
        { Type: "Text", Text: "{{ cashout_reference }}", callback: "right", Label: "Cashout Code" },
        ...this.footer(),
        { Type: "Text", Text: "Receiver may pickup money at the nearest", callback: "center" },
        { Type: "Text", Text: "SunCash store or redeem in the SunCash app.", callback: "center" },
        { Type: "Text", Text: "Cashout Codes are only valid for 90 days.", callback: "center" },
      ]
    });
  }

  public getCreditVoucherReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ voucher_value }}", callback: "right", Label: "Voucher Value" },
        { Type: "Text", Text: "{{ fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ voucher_code }}", callback: "right", Label: "Voucher Code" },
        { Type: "Text", Text: "{{ voucher_pin }}", callback: "right", Label: "Voucher PIN" },
        { Type: "Text", Text: "-".repeat(this.length), callback: "center" },
        { Type: "Text", Text: "{{ message }}", callback: "center" },
        { Type: "Text", Text: "{{ voucher_value }}", callback: "right", Label: "Credit Voucher" },
        ...this.footer(),
        ...this.cvFooter(),
      ]
    });
  }

  public getUtilityReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ transaction_id }}", callback: "right", Label: "Transaction ID" },
        { Type: "Text", Text: "{{ biller }}", callback: "right", Label: "Utility Company" },
        { Type: "Text", Text: "{{ account_number }}", callback: "right", Label: "Account Number" },
        { Type: "Text", Text: "{{ account_name }}", callback: "right", Label: "Account Name" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "Vat" },
        { Type: "Text", Text: "{{ total_deposited }}", callback: "right", Label: "Amount" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        ...this.footer()
      ]
    });
  }

  public getBankDepositReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "", callback: "right", Label: "Recipient Info" },
        { Type: "Text", Text: "{{ recipient_accountNumber }}", callback: "right", Label: "  Account Number" },
        { Type: "Text", Text: "{{ recipient_accountType }}", callback: "right", Label: "  Account Type" },
        { Type: "Text", Text: "{{ recipient_bankBranch }}", callback: "right", Label: "  Bank Branch" },
        { Type: "Text", Text: "{{ recipient_bankName }}", callback: "right", Label: "  Bank Name" },
        { Type: "Text", Text: "{{ delivery_type }}", callback: "right", Label: "Delivery Type" },
        { Type: "Text", Text: "{{ delivery_fee }}", callback: "right", Label: "Delivery Fee" },
        { Type: "Text", Text: "{{ total_deposited }}", callback: "right", Label: "Amount Deposited" },
        { Type: "Text", Text: "{{ recipient }}", callback: "right", Label: "Recipient gets" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        { Type: "Text", Text: "{{ cashout_reference }}", callback: "right", Label: "Cashout Ref. Number" },
        ...this.footer()
      ]
    });
  }
  public getCardWithdrawalReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ requested_amount }}", callback: "right", Label: "Requested Amount" },
        { Type: "Text", Text: "{{ cash }}", callback: "right", Label: "Cash Dispensed" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ name }}", callback: "right", Label: "Name" },
        { Type: "Text", Text: "{{ card }}", callback: "right", Label: "Card Number" },
        { Type: "Text", Text: "{{ issuer }}", callback: "right", Label: "Issuer" },
        { Type: "Text", Text: "{{ approval_code }}", callback: "right", Label: "Approval Code" },
        { Type: "Text", Text: "{{ approved_amount }}", callback: "right", Label: "Approved Amount" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        ...this.footer()
      ]
    });
  }

  public getCardDepositReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.header(),
        { Type: "Text", Text: "{{ settlement_time }}", callback: "right", Label: "Settlement Time" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Amount" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Fee" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT" },
        { Type: "Text", Text: "{{ name }}", callback: "right", Label: "Name" },
        { Type: "Text", Text: "{{ card }}", callback: "right", Label: "Card Number" },
        { Type: "Text", Text: "{{ issuer }}", callback: "right", Label: "Issuer" },
        { Type: "Text", Text: "{{ approval_code }}", callback: "right", Label: "Approval Code" },
        { Type: "Text", Text: "{{ approved_amount }}", callback: "right", Label: "Approved Amount" },
        { Type: "Text", Text: "{{ service }}", callback: "right", Label: "Service" },
        ...this.footer()
      ]
    });
  }

  public getWuSendReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.wuHeader(),
        { Type: "Text", Text: "{{ sender }}", callback: "right", Label: "SENDER:" },
        { Type: "Text", Text: "{{ sender_address }}", callback: "right", Label: "Address:" },
        { Type: "Text", Text: "{{ telno }}", callback: "right", Label: "Telephone:" },
        { Type: "Text", Text: "{{ sender_id_type }}", callback: "right", Label: "ID Type:" },
        { Type: "Text", Text: "{{ sender_id_number }}", callback: "right", Label: "ID No:" },
        // this.enter(),
        { Type: "Text", Text: "{{ receiver }}", callback: "right", Label: "RECEIVER:" },
        { Type: "Text", Text: "_ YES  _ NO ", callback: "right", Label: "Will Receiver have valid ID?" },
        { Type: "Text", Text: "{{ question }}", callback: "right", Label: "Test Question:" },
        { Type: "Text", Text: "{{ answer }}", callback: "right", Label: "Answer:" },
        { Type: "Text", Text: "{{ optional_services }}", callback: "right", Label: "Optional Services:" },
        { Type: "Text", Text: "{{ receiver_city }}", callback: "right", Label: "Receiver City:" },
        { Type: "Text", Text: "{{ receiver_state }}", callback: "right", Label: "Receiver State:" },
        { Type: "Text", Text: "{{ receiver_country }}", callback: "right", Label: "Country:" },
        // this.enter(),
        { Type: "Text", Text: "{{ date_time }}", callback: "right", Label: "Date & Time" },
        { Type: "Text", Text: "{{ agent_name }}", callback: "right", Label: "Agent Name" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ destination_country }}", callback: "right", Label: "Destination" },
        // this.enter(),
        { Type: "Text", Text: "{{ mtcn }}", callback: "right", Label: "MTCN : " },
        { Type: "Text", Text: "{{ collection_currency }}", callback: "right", Label: "Collection Currency:" },
        // this.enter(),
        { Type: "Text", Text: "{{ amount }}", callback: "right", Label: "Amount" },
        { Type: "Text", Text: "{{ charge }}", callback: "right", Label: "Send Charge" },
        { Type: "Text", Text: "{{ promotion_code }}", callback: "right", Label: "Promotion code:" },
        { Type: "Text", Text: "{{ vat }}", callback: "right", Label: "VAT - TIN #{{ tin_id }}:" },
        { Type: "Text", Text: "{{ fx_fee }}", callback: "right", Label: "Foreign Exchange Fee:" },
        { Type: "Text", Text: "{{ stamp_tax }}", callback: "right", Label: "Government Stamp Tax:" },
        { Type: "Text", Text: "{{ convenience_fee }}", callback: "right", Label: "Convenience Fee:" },
        this.hr(),
        { Type: "Text", Text: "{{ total }}", callback: "right", Label: "TOTAL:" },
        this.hr(),
        { Type: "Text", Text: "{{ payout_amount }}", callback: "right", Label: "Payout Amount:" },
        { Type: "Text", Text: "{{ total_tax }}", callback: "right", Label: "Total Tax:" },
        { Type: "Text", Text: "{{ exchange_rate }}", callback: "right", Label: "Exchange Rate:" },
        ...this.footer()
      ]
    });
  }

  public getWuReceiveReceiptTemplate() {
    return this.receiptString({
      Items: [
        ...this.wuHeader(),
        { Type: "Text", Text: "RECEIVER : {{ receiver }}", callback: "left" },
        { Type: "Text", Text: "Address : {{ receiver_address }}", callback: "left" },
        { Type: "Text", Text: "ID Type : {{ receiver_id_type }}", callback: "right", Label: "ID No : {{ receiver_id_number }}" },
        // this.enter(),
        { Type: "Text", Text: "SENDER : {{ sender }}", callback: "left" },
        // this.enter(),
        { Type: "Text", Text: "{{ date_time }}", callback: "right", Label: "Date & Time" },
        { Type: "Text", Text: "{{ agent_name }}", callback: "right", Label: "Agent Name" },
        { Type: "Text", Text: "{{ terminal_id }}", callback: "right", Label: "Terminal ID" },
        { Type: "Text", Text: "{{ originating_country }}", callback: "right", Label: "Originating Country" },
        // this.enter(),
        { Type: "Text", Text: "{{ mtcn }}", callback: "right", Label: "MTCN : " },
        { Type: "Text", Text: "{{ payout_currency }}", callback: "right", Label: "Payout Currency:" },
        { Type: "Text", Text: "{{ payout_cash }}", callback: "right", Label: "Amount Received" },
        { Type: "Text", Text: "{{ sent_amount }}", callback: "right", Label: "Amount Sent" },
        { Type: "Text", Text: "{{ sent_currency }}", callback: "right", Label: "Currency Sent:" },
        // this.enter(),
        this.hr(),
        { Type: "Text", Text: "Voucher", callback: "left" },
        { Type: "Text", Text: "{{ voucher_amount }}", callback: "right", Label: "Amount:" },
        { Type: "Text", Text: "{{ voucher_code }}", callback: "right", Label: "Code:" },
        { Type: "Text", Text: "{{ voucher_pin }}", callback: "right", Label: "PIN" },
        this.hr(),
        { Type: "Text", Text: "{{ exchange_rate }}", callback: "right", Label: "Exchange Rate:" },
        { Type: "Text", Text: "{{ tax }}", callback: "right", Label: "Tax:" },
        this.hr(),
        { Type: "Text", Text: "{{ total }}", callback: "right", Label: "TOTAL:" },
        ...this.footer()
      ]
    });
  }

  receiptString<T extends Record<string, unknown>>(items: { Items: IReceiptItem<T>[] }) {
    return JSON.stringify(items)
  }

  header<T extends Record<string, unknown>>(): IReceiptItem<T>[] {
    return [
      { Type: "Image", ImageMarginLeft: this.length / 4, FilePath: "C:\\Engage\\Assets\\fastpay-logo.bmp", HtmlPath: "https://kioskdev.mysuncash.com/assets/images/fastpay-logo-black.png" },
    ]
  }

  wuHeader<T extends Record<string, unknown>>(): IReceiptItem<T>[] {
    return [
      { Type: "Image", ImageMarginLeft: this.length / 4, FilePath: "C:\\Engage\\Assets\\wu-logo.bmp", HtmlPath: "https://kioskdev.mysuncash.com/assets/images/wu-logo-black.png" },
    ]
  }

  footer<T extends Record<string, unknown>>(): IReceiptItem<T>[] {
    return [
      this.hr(),
      { Type: "Text", Text: "How to reach customer service", callback: "center" },
      { Type: "Text", Text: "Phone: (242) 393 4777", callback: "center" },
      { Type: "Text", Text: "Whatsapp: (242) 801 4744", callback: "center" },
      { Type: "Text", Text: "Email: fastpay@mysuncash.com", callback: "center" },
    ]
  }

  creditVoucher<T extends Record<string, unknown>>(data: CVInfo): IReceiptItem<T>[] {
    return data && data.credit_voucher_value ? [
      this.hr(),
      { Type: "Text", Text: "Failed to dispense full amount.", callback: "center" },
      { Type: "Text", Text: "Credit Voucher: ", callback: "left" },
      { Type: "Text", Text: "{{ credit_voucher_value }}", callback: "right", Label: "Value" },
      { Type: "Text", Text: "{{ credit_voucher_code }}", callback: "right", Label: "Code" },
      { Type: "Text", Text: "{{ credit_voucher_pin }}", callback: "right", Label: "PIN" },
      this.hr(),
      ...this.cvFooter(),
    ] : []
  }

  public hr<T extends Record<string, unknown>>() {
    return { Type: "Text", Text: "-".repeat(this.length), callback: "center" } as IReceiptItem<T>;
  }

  cvFooter<T extends Record<string, unknown>>() {
    return [
      {
        Type: "Text", Text: "Redeem your credit voucher into", callback: "center"
      },
      { Type: "Text", Text: "the SunCash App, at pay.mysuncash.com", callback: "center" },
      { Type: "Text", Text: "or any SunCash Store.", callback: "center" },
    ] as IReceiptItem<T>[]
  }
}
